import QuizSubmittedBanner from "@/components/banners/quiz-submitted-banner";
import WaitingQuestionnaire from "@/modules/home/waiting-questionnaire";
import { FC, HTMLAttributes } from "react";
import QuizCompletedBanner from "./quiz-completed-banner";
import QuizIncompleteBanner from "./quiz-incomplete-banner";
import QuizRereviewBanner from "./quiz-rereview-banner";
import QuizResultsReadyBanner from "./quiz-results-ready-banner";
import QuizUnderReviewBanner from "./quiz-under-review-banner";

type QuizBannersProps = HTMLAttributes<HTMLDivElement>;

const QuizBanners: FC<QuizBannersProps> = (props) => {
  return (
    <div {...props}>
      <WaitingQuestionnaire />

      <QuizUnderReviewBanner />

      <QuizRereviewBanner />

      <QuizCompletedBanner />

      <QuizSubmittedBanner />

      <QuizResultsReadyBanner />

      <QuizIncompleteBanner />
    </div>
  );
};

export default QuizBanners;
